import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { adminSearchSupplements } from '@api/adminSupplements';
import { IFetchListRequestProps } from '@interfaces/common';
import { IDietarySupplementSearchResult } from '@interfaces/supplements';

import { buildAdminSearchSupplementsPayload } from './utils';

export const handleAdminSearchSupplements = createAsyncThunk<
  AxiosResponse<IDietarySupplementSearchResult>,
  IFetchListRequestProps
>('adminSearchSupplements', props =>
  adminSearchSupplements(buildAdminSearchSupplementsPayload(props)),
);
